import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserService } from '@fg-services/user.service';
import { CmMedia } from '@fg-types/cm-media';
import { IConvention } from '@fg-types/convention.type';
import { TIME_ZONES } from '@fg-environments/assets';
import { ApiService } from '@fg-services/api/api.service';

export interface FgNewConventionFormOutput {
  convention: Partial<IConvention>;
  orgId: string;
}
@Component({
  selector: 'fg-new-convention-form',
  templateUrl: './fg-new-convention-form.component.html',
  styleUrls: ['./fg-new-convention-form.component.scss']
})
export class FgNewConventionFormComponent implements OnInit {
  @Output() cancel = new EventEmitter();
  @Output() save = new EventEmitter<FgNewConventionFormOutput>();
  @Input() orgId: string;
  organizations =
    this.userService.roles?.organizationsAdmining?.map(o => ({
      label: o.name,
      value: o.id
    })) ?? [];

  convention: Partial<IConvention> = {};
  eventType: string;
  roles = this.userService.roles;
  timezones = TIME_ZONES;
  categoriesOptions: { label: string; value: string }[] = [];
  selectedCategories: string[] = [];
  constructor(private userService: UserService, private api: ApiService) {
    this.orgId = this.organizations?.[0]?.value ?? '';
  }

  ngOnInit(): void {
    // Fetch categories for multi-select
    this.api.search
      .searchCategories('', 'Global', null, null)
      .subscribe(({ items }) => {
     
        this.categoriesOptions = (items ?? []).map(c => ({ label: c.name, value: c.id }));
    
      });
  }
  setImage(image: CmMedia) {
    this.convention.logoHorizontal = image;
    this.convention.logoHorizontalId = image.id;
  }

  deleteImage() {
    this.convention.logoHorizontal = null;
    this.convention.logoHorizontalId = null;
  }

  saveConvention() {
    // Include selected categories as array of strings on convention payload
    this.convention.eventCategoryIds = this.selectedCategories.map((category:any)=>{
      return typeof category ==='object' ? category.value :category
    });

    this.save.emit({ convention: this.convention, orgId: this.orgId });
  }
}
